import styled from '@emotion/styled/macro'
import ReactSelect from 'react-select'
import startCase from 'lodash/startCase'
const Form = styled('form')`
    /* background: var(--colors-grays-20); */
    /* border-radius: var(--borderRadius-xl); */
    width: 100%;
    height: fit-content;
    margin: 1em auto;
    box-sizing: border-box;
    .form-body {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
        grid-gap: 0.5rem;
        grid-template-rows: repeat(auto-fill, minmax(50px, 1fr));
    }
    .form-footer {
        margin-top: 0.75em;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: flex-end;
        button {
            padding: 0.5em 2em;
            margin-left: 0.75em;
        }
    }
`

export const StyledInput = styled('div')`
    label {
        font-size: var(--typography-fontSizes-small);
        font-weight: bold;
    }
    width: 100%;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    ${({ span }) => (span ? `grid-column:${span};` : '')}
    input,
    textarea {
        border: var(--borders-main);
        outline: none;
        padding: 0.75em;
        border-radius: var(--borderRadius-sm);
        height: fit-content;
        /* &[type='color'] {
            position: relative;
            width: 100%;
            height: 2rem;
            margin: 0;
            padding: 0;
        } */
    }
    input[inputMode='none'] {
        padding: 0;
    }
`
const Required = styled('span')`
    color: red;
`
export const StyledInputGroup = ({
    name,
    label = name,
    required,
    span,
    style,
    children,
    onClick,
}) => (
    <StyledInput span={span} style={style} onClick={onClick}>
        {(label || name) && (
            <label htmlFor={name || label}>
                {startCase(label || name)} {required && <Required>*</Required>}
            </label>
        )}
        {children}
    </StyledInput>
)
export const NoEditInput = ({
    name,
    label = name,
    required,
    span,
    style,
    Component,
    formState,
    ...props
}) => {
    return (
        <StyledInput span={span} style={style}>
            <p>{label}</p>
            <Component value={value} disabled></Component>
        </StyledInput>
    )
}
export const Input = ({
    name,
    label = name,
    required,
    span,
    style,
    Component,
    formState,
    noEdit,
    ...props
}) => {
    return (
        <StyledInput span={span} style={style}>
            {(label || name) && (
                <label htmlFor={name || label}>
                    {startCase(label || name)}{' '}
                    {required && <Required>*</Required>}
                </label>
            )}
            {Component ? (
                <Component
                    {...{ ...props, name: name || label, required, noEdit }}
                />
            ) : (
                <input
                    {...{ ...props, name: name || label, required }}
                    disabled={noEdit}
                />
            )}
        </StyledInput>
    )
}

export const TextArea = ({ formState, ...p }) => (
    <StyledInputGroup {...p}>
        <textarea {...p}></textarea>
    </StyledInputGroup>
)
export const Select = (props) => {
    const customStyles = {
        menu: (provided, state) => ({
            ...provided,
            borderRadius: 'var(--borderRadius-sm)',
            border: 'var(--borders-main)',
            overflow: 'hidden',
        }),

        control: (
            provided,
            { selectProps: { width = '100%', column = '1 / -1' } }
        ) => ({
            ...provided,
            width: width,
            borderRadius: 'var(--borderRadius-sm)',
            border: 'var(--borders-main)',
        }),
    }
    const mapOntoProps = (val) => {
        if (val?.value) return val
        const res = props.options.find(
            ({ value }) =>
                (value?._id && value?._id === val?._id) || value == val
        )
        console.log({ opts: props.options, res, val })
        if (res)
            return {
                value: res.value,
                label: res.label || startCase(res.value),
            }
        if (typeof val === 'string') {
            return { value: val, label: startCase(val) }
        }
    }
    const value = Array.isArray(props.value)
        ? props.value.map(mapOntoProps)
        : mapOntoProps(props.value)
    return (
        <StyledInputGroup {...props}>
            <ReactSelect
                {...props}
                value={value}
                options={props.options?.map((option) =>
                    typeof option === 'string'
                        ? { value: option, label: startCase(option) }
                        : {
                              value: option.value,
                              label: option.label || startCase(option.value),
                          }
                )}
                onChange={(ch) => {
                    return props.onChange(
                        Array.isArray(ch)
                            ? ch.map(({ value }) => value)
                            : ch.value
                    )
                }}
                styles={customStyles}
            />
        </StyledInputGroup>
    )
}
export const withStyledInputGroup = (Component) => (props) =>
    (
        <StyledInputGroup {...props}>
            <Component {...props}></Component>
        </StyledInputGroup>
    )
export default Form
